import { createSelector } from 'reselect';
import { get } from './user';

export const isSignedIn = createSelector(
    get,
    ({ uid }) => Boolean(uid)
);
